import { GA4Event } from '@jusbrasil-web/shared-ga4'

import { EVENT } from '../constants'

export interface GA4InputSubmitEventProps {
  componentClass?: string | null
  componentName?: string | null
  featureClass?: string | null
  featureName?: string | null
  inputMethod: string
  successfulAttempt: boolean
  selectedOption?: string | null
}

export class GA4InputSubmitEvent extends GA4Event {
  ga4_component_class: GA4InputSubmitEventProps['componentClass']
  ga4_component_name: GA4InputSubmitEventProps['componentName']
  ga4_feature_class: GA4InputSubmitEventProps['featureClass']
  ga4_feature_name: GA4InputSubmitEventProps['featureName']
  ga4_input_method: GA4InputSubmitEventProps['inputMethod']
  ga4_successful_attempt: GA4InputSubmitEventProps['successfulAttempt']
  ga4_selected_option: GA4InputSubmitEventProps['selectedOption']

  constructor({
    componentClass = null,
    componentName = null,
    featureClass = null,
    featureName = null,
    inputMethod,
    successfulAttempt,
    selectedOption = null,
  }: GA4InputSubmitEventProps) {
    super({ event: EVENT.INPUT_SUBMIT })

    this.ga4_component_class = componentClass
    this.ga4_component_name = componentName
    this.ga4_feature_class = featureClass
    this.ga4_feature_name = featureName
    this.ga4_input_method = inputMethod
    this.ga4_successful_attempt = successfulAttempt
    this.ga4_selected_option = selectedOption
  }
}
